<!--
 * @Author: jzh
 * @Date: 2020-03-17 09:56:45
 * @Description: 新增或更新岗位弹窗
 * @LastEditTime: 2021-05-04 11:20:55
 * @LastEditors: DQL
 -->
<template>
  <el-dialog
    v-loading="loading"
    class="o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-70 o-dialog--xl-50 page-roleUpdate"
    :title="dialogTitle"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section
      class="page-roleUpdate__body"
    >
      <div
        class="page-roleUpdate__title"
      >
        岗位基本信息
      </div>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :rules="fdRules"
        :inline="true"
        label-position="right"
        label-width="140px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="岗位分类"
              prop="roleTypeName"
            >
              <span
                class="c-form__read"
              >
                {{ dlParams.roleTypeName }}
              </span>
            </el-form-item>
          </el-col>
          <!-- <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="岗位类型"
              prop="roleTypeNameValue"
            >
              <span
                class="c-form__read"
              >
              {{ dlParams.roleTypeNameValue }}
              </span>
            </el-form-item>
          </el-col> -->
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="岗位代码"
              prop="roleCode"
            >
              <el-input
                v-if="isAdd()"
                v-model="fd.roleCode"
                class="c-form__input"
                placeholder="岗位代码"
              />
              <span v-if="!isAdd()">
                {{ fd.roleCode }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="岗位名称"
              prop="roleName"
            >
              <el-input
                v-model="fd.roleName"
                class="c-form__input"
                placeholder="岗位名称"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="岗位职责"
              prop="roleDescription"
            >
              <el-input
                v-model="fd.roleDescription"
                class="c-form__input"
                placeholder="岗位职责"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="安全控制类别"
              prop="securityType"
            >
              <el-select
                v-model="fd.securityType"
                class="c-form__select"
                style="width: 100%;"
                placeholder="请选择"
              >
                <!-- <el-option
                  v-for="item in enums.CERTIFICATE"
                  :key="item.cateNameEn"
                  :label="item.enumValue"
                  :value="item.cateNameEn">
                </el-option> -->
                <el-option
                  v-for="item in enums.BASE_SECURITY_TYPE"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col
            v-if="fd.roleType==='APP'"
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="业务系统"
              prop="appCode"
            >
              <el-select
                v-model="fd.appCode"
                class="c-form__select"
                style="width: 100%;"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in appList"
                  :key="item.appCode"
                  :label="item.appName"
                  :value="item.appCode"
                />
              </el-select>
            </el-form-item>
          </el-col> -->
        </el-row>
      </el-form>

      <div
        class="dev-adminPer"
      >
        <div
          class="page-roleUpdate__title"
        >
          管理员权限配置
        </div>
        <span
          class="u-text-warning"
        >（【查询】是基础权限，授权其他权限时，需要授权【查询】）</span>
        <div
          class="dev-adminPer__dTitle dev-adminPer__item"
        >
          <div
            class="dev-adminPer__name"
          >
            管理员级别
          </div>
          <div
            class=" dev-adminPer__per"
          >
            权限
          </div>
        </div>
        <div
          class="dev-adminPer__detail"
        >
          <div
            v-for="(adminLevel, index) in adminLevelList"
            :key="'adminPer_' + adminLevel.adminLevel"
            class="dev-adminPer__item"
          >
            <div
              class=" dev-adminPer__name"
            >
              {{ adminLevel.name }}
            </div>
            <div
              class=" dev-adminPer__per"
            >
              <el-checkbox-group
                v-model="fd.permissions[index].permissions"
                class="dev-adminPer__checkbox-group"
              >
                <template
                  v-for="_perItem in permissionList"
                >
                  <el-checkbox
                    :key="adminLevel.uuid + '_' + _perItem.permissionCode"
                    class="dev-pDetail"
                    :label="_perItem.permissionCode"
                  >
                    {{ _perItem.permissionName }}
                  </el-checkbox>
                </template>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <el-button
        v-if="isAdd()"
        type="primary"
        @click="handleAdd()"
      >
        保存
      </el-button>
      <el-button
        v-if="!isAdd()"
        type="primary"
        :loading="loading"
        @click="handleUpdate()"
      >
        保存
      </el-button>
      <el-button
        @click="closeDialog()"
      >
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash';
import { roleService } from '@/features/system/role/role.service.js';
export default {
  name: 'RoleUpdateDialog', // 新增或更新岗位弹窗
  props: {
    dlParams: {
      type: Object,
      default () {
        return {};
      },
      required: true
    }
  },
  data () {
    return {
      loading: true, // 页面loading状态
      dialogShow: true, // 模态框dialog显示

      dialogTitle: this.isAdd() ? '新增' : '修改', // 弹窗标题

      /* 表单参数 Start */
      fd: {
        orderNum: 0,
        roleTypeDm: '',
        roleCode: '',
        roleName: '',
        roleDescription: '',
        securityType: '',
        roleType: '', // 岗位类型
        appCode: null,
        permissions: []
      },
      /* 表单参数 End */

      /* 表单校验规则 Start */
      fdRules: {},
      fdRules1: {
        roleCode: [this.$validUtils.required('岗位代码'), this.$HMValidator.maxLength('岗位代码', 36)],
        roleName: [this.$validUtils.required('岗位名称'), this.$HMValidator.maxLength('岗位名称', 30)],
        roleDescription: [this.$HMValidator.maxLength('岗位职责', 30)],
        securityType: [this.$validUtils.required('安全控制类别')]
      },
      /* 表单校验规则 End */

      /* 表单校验规则 Start */
      fdRules2: {
        roleCode: [this.$validUtils.required('岗位代码'), this.$HMValidator.maxLength('岗位代码', 36)],
        roleName: [this.$validUtils.required('岗位名称'), this.$HMValidator.maxLength('岗位名称', 30)],
        roleDescription: [this.$HMValidator.maxLength('岗位职责', 30)],
        securityType: [this.$validUtils.required('安全控制类别')],
        appCode: [this.$validUtils.required('业务系统')]
      },
      /* 表单校验规则 End */
      appList: [],
      adminLevelList: [], // 管理员级别列表
      permissionList: [] // 权限列表
    };
  },
  computed: {
    // 获取枚举
    enums () {
      return this.$HMStoreService.getEnums();
    }
  },
  methods: {
    /**
     * @description: 依据传入参数判断是否新增操作
     * @param {*}
     * @return {*}
     */
    isAdd () {
      return this.dlParams.roleCode === undefined;
    },
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    /**
     * @description: 读取岗位信息
     * @param {*}
     * @return {*}
     */
    },
    getRole () {
      const _this = this;
      this.loading = true;
      roleService.getRole(this.dlParams.roleCode)
        .then(rsp => {
          const { data } = rsp;
          this.adminLevelList.forEach((item, index) => {
            const _permission = _.find(data.permissions, function (_per) {
              if (item.adminLevel === _per.adminLevel) {
                return _per;
              }
            });
            _this.fd.permissions[index].permissions = _permission.permissions;
          });
          this.fd = Object.assign(this.fd, data);
        })
        .catch(err => {
          console.error('查询岗位出错', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 新增
     * @param {*}
     * @return {*}
     */
    handleAdd () {
      this.$refs.fd.validate((valid) => {
        if (valid) {
          this.loading = true;
          roleService.addRole(this.fd)
            .then(rsp => {
              this.$alert('新增岗位成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success'
              });
              this.$emit('closeDialog', '');
              this.$emit('callback');
            })
            .catch(err => {
              console.error('新增岗位出错', err);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
      );
    },
    /**
     * @description: 更新岗位处理
     * @param {*}
     * @return {*}
     */
    handleUpdate () {
      this.$refs.fd.validate((valid) => {
        if (valid) {
          this.loading = true;
          roleService.updateRole(this.fd)
            .then(rsp => {
              this.$alert('岗位更新成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success'
              });
              this.$emit('closeDialog', '');
              this.$emit('callback');
            })
            .catch(err => {
              console.error('更新岗位出错', err);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    /* 业务系统start */
    /**
     * @description: 读取业务系统列表
     * @return {*}
     */
    getAppList () {
      roleService.getAppList()
        .then(rsp => {
          this.appList = rsp.data;
          if (!this.isAdd()) {
            this.fd.appCode = 'base';
          }
        })
        .catch(err => {
          console.error('查询菜单出错', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 获取管理员级别权限数据
     * @param {*}
     * @return {*}
     */
    getAdminLevel () {
      roleService.getPermission()
        .then(rsp => {
          this.adminLevelList = rsp.data.adminLevel;
          this.permissionList = rsp.data.permission;
          rsp.data.adminLevel.forEach((item, index) => {
            this.$set(this.fd.permissions, index, {
              adminLevel: item.adminLevel,
              permissions: []
            });
          });
        })
        .catch(err => {
          console.error('获取管理员级别权限失败！', err);
        })
        .finally(() => {
        });
    }
  },
  created () {
    // 1. 读取roleTypeDm 必须
    this.fd.roleTypeDm = this.dlParams.roleTypeDm;
    this.fd.roleType = this.dlParams.roleType;
    this.fdRules = this.fd.roleType === 'APP' ? this.fdRules2 : this.fdRules1;
    // 2. 判断roleTypeDm不存在则抛出错误
    if (this.fd.roleTypeDm === '') {
      this.$alert('请重新选择岗位分类后再操作！', '提示', {
        type: 'warning',
        callback: () => {
          this.closeDialog();
        }
      });
    }
    // 3. 如果传入岗位代码则代表修改
    this.getAppList();
    this.getAdminLevel();
    if (!this.isAdd()) {
      this.getRole();
    } else {
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
.page-roleUpdate{
  &__title{
    display: flex;
    position: relative;
    align-items: center;
    margin-bottom: 4px;
    line-height: 26px;

    &::before{
      content: "";
      display: block;
      height: 14px;
      margin-right: 8px;
      border-left: 4px solid #2296f7;
    }
  }

  .dev-adminPer{
    margin-top: 14px;
    line-height: 26px;

    &__dTitle{
      border: 1px solid #d6d6d6;
      font-weight: 600;
      text-align: center;
      background: #eee;
    }

    &__detail{
      border: 1px solid #d6d6d6;
      border-top: none;
    }

    &__item{
      display: flex;

      &:not(:last-child){
        border-bottom: 1px solid #d6d6d6;
      }
    }

    &__name{
      flex-shrink: 0;
      box-sizing: border-box;
      width: 140px;
      padding: 2px 10px;
      word-break: break-word;
    }

    &__per{
      display: flex;
      flex: 1;
      padding: 2px 10px;
      border-left: 1px solid #d6d6d6;
      word-break: break-word;
    }
  }

  &__body{
    margin-top: -16px;
    margin-bottom: -10px;
  }
}
</style>
